import GoogleAd from '../GoogleAds';
import CardArticleLoading from '../DiscoveryComponent/MiddleContentComponent/components/card-article-loading.component';
import EmptyArticleComponent from '../EmptyArticleComponent';
import EmptyProfileState from '../../routes/Profile/components/EmptyProfileState';
import CardComment from '../DiscoveryComponent/MiddleContentComponent/components/card-comment.component';
import { profileAtom } from '../Settings/atom';
import { useAtom } from 'jotai';

const CommentContainer = ({
  loading,
  listComments,
  isHiddenFeaturedArticles,
  type,
  isMyProfile
}) => {
  const [profile] = useAtom(profileAtom);
  const renderContentWithAds = () => {
    const contentWithAds = [];
    listComments.forEach((comment, index) => {
      contentWithAds.push(
        <CardComment
          key={`article-${index}`}
          index={index}
          item={comment}
          isHiddenFeaturedArticles={true}
          isMyProfile={isMyProfile}
          isMyArticle={profile.id === comment?.article?.creatorId}
        />
      );
      if ((index + 1) % 4 === 0) {
        contentWithAds.push(
          <GoogleAd
            articleId={comment?.article?.id}
            key={`ad-${index}`}
            slot="1625116786"
            className="my-custom-ad !z-10"
          />
        );
      }
    });
    return contentWithAds;
  };

  return (
    <div className="pb-[30px] w-full">
      <div className="md:px-0 flex flex-col gap-4">
        {renderContentWithAds()}
        {loading &&
          [...Array(3)].map((_, i) => (
            <CardArticleLoading
              key={i}
              index={i}
              isHiddenFeaturedArticles={isHiddenFeaturedArticles}
            />
          ))}

        {listComments.length === 0 && !loading && isMyProfile && (
          <EmptyArticleComponent categoryType={type} />
        )}
        {listComments.length === 0 && !loading && !isMyProfile && (
          <EmptyProfileState categoryType={type} />
        )}
      </div>
    </div>
  );
};

export default CommentContainer;
